import React, { FC } from 'react';

const iconForefinger = require('./icon_forefinger.svg');

export const IconForefinger: FC = () => {
  return <img src={iconForefinger} width={78} height={86} alt="icon_forefinger" />;
};

IconForefinger.displayName = 'IconForefinger';
